import { createSlice } from '@reduxjs/toolkit';

const MAX_CACHE_SIZE = 30;
const CACHE_TTL = 3 * 60 * 1000;

const cacheSlice = createSlice({
    name: 'cache',
    initialState: {
        cache: {},
    },
    reducers: {
        updateCache: (state, action) => {
            const { key, data } = action.payload;

            const cacheKeys = Object.keys(state.cache);
            if (cacheKeys.length >= MAX_CACHE_SIZE) {
                let oldestKey = cacheKeys[0];
                let oldestTime =
                    state.cache[oldestKey]?.timestamp || Date.now();

                cacheKeys.forEach((k) => {
                    const time = state.cache[k]?.timestamp || Date.now();
                    if (time < oldestTime) {
                        oldestTime = time;
                        oldestKey = k;
                    }
                });

                delete state.cache[oldestKey];
            }

            state.cache[key] = {
                data,
                timestamp: Date.now(),
            };
        },

        removeCache: (state, action) => {
            const { key } = action.payload;
            if (state.cache[key]) {
                delete state.cache[key];
            }
        },

        clearExpiredCache: (state) => {
            const now = Date.now();
            Object.keys(state.cache).forEach((key) => {
                if (now - state.cache[key].timestamp > CACHE_TTL) {
                    delete state.cache[key];
                }
            });
        },

        clearAllCache: (state) => {
            state.cache = {};
        },
    },
});

export const { updateCache, removeCache, clearExpiredCache, clearAllCache } =
    cacheSlice.actions;

export const cache = cacheSlice.reducer;
